module.exports = __webpack_public_path__ + "img/IconRMG.2a3a9d41.png";